export const createParseWorker = () => {
  return new Worker(
    new URL("./parseWorker.js", import.meta.url),
    { type: "module" }
  )
}